import { useEffect } from 'react';
import { X } from 'lucide-react';

const privacy = `Adatvédelmi nyilatkozat

1. Általános rendelkezések
Az AuraCode (a továbbiakban: Szolgáltató) elkötelezett a felhasználók személyes adatainak védelme iránt. Jelen adatvédelmi tájékoztató célja, hogy ismertesse a Szolgáltató által kezelt személyes adatok körét, az adatkezelés célját, jogalapját, időtartamát, valamint a felhasználók adatkezeléssel kapcsolatos jogait.

2. Az adatkezelő adatai
Név: AuraCode
E-mail: info@auracode.hu
Székhely: Budapest, Magyarország

3. Kezelt adatok köre és célja

3.1. Kapcsolatfelvételi űrlap
Kezelt adatok: név, e-mail cím, telefonszám, üzenet tartalma
Cél: Kapcsolatfelvétel, ajánlatkérés kezelése, ügyfélszolgálat biztosítása
Jogalap: Az érintett hozzájárulása (GDPR 6. cikk (1) bekezdés a) pont)

3.2. Weboldal használata
Kezelt adatok: IP cím, böngésző típusa, operációs rendszer, látogatás időpontja
Cél: Weboldal működésének biztosítása, statisztikák készítése
Jogalap: A Szolgáltató jogos érdeke (GDPR 6. cikk (1) bekezdés f) pont)

4. Adatkezelés időtartama
Kapcsolatfelvételi adatok: Az ajánlat elkészítéséig, vagy az érintett törlési kérelméig, de maximum 2 év
Szerződéses adatok: A szerződés teljesítését követően 5 év (számviteli kötelezettség miatt)
Technikai adatok: 90 nap

5. Adattovábbítás, adatfeldolgozók
A Szolgáltató a következő adatfeldolgozókat veszi igénybe:
- Formspree: Kapcsolatfelvételi űrlap kezelése (székhelye: USA)
- Tárhely szolgáltató: Weboldal üzemeltetése

A Szolgáltató harmadik országba történő adattovábbítás esetén gondoskodik a megfelelő garanciák meglétéről.

6. Az érintettek jogai
- Hozzáférés joga: Tájékoztatás kérése a kezelt személyes adatokról
- Helyesbítés joga: Pontatlan adatok helyesbítésének kérése
- Törlés joga: Az "elfeledtetéshez való jog" gyakorlása
- Korlátozás joga: Az adatkezelés korlátozásának kérése
- Tiltakozás joga: Tiltakozás a jogos érdeken alapuló adatkezelés ellen
- Adathordozhatóság joga: Adatok strukturált, géppel olvasható formátumban történő kérése
- Hozzájárulás visszavonása: A hozzájárulás bármikor visszavonható

7. Jogorvoslat
Panasz esetén az érintett a következő hatósághoz fordulhat:
Nemzeti Adatvédelmi és Információszabadság Hatóság
Székhely: 1055 Budapest, Falk Miksa utca 9-11.
Levelezési cím: 1363 Budapest, Pf. 9.
Telefon: +36-1-391-1400
E-mail: ugyfelszolgalat@naih.hu
Honlap: www.naih.hu

8. Adatbiztonság
A Szolgáltató a személyes adatok biztonságát korszerű technikai és szervezési intézkedésekkel védi. Az adatokat titkosított kapcsolaton keresztül továbbítjuk, és biztonságos szervereken tároljuk.

9. Cookie-k (sütik) használata
A weboldal működéséhez szükséges sütiket használ. Ezek a sütik biztosítják a weboldal megfelelő működését, és nem tárolnak személyes adatokat. Elemző célú sütiket csak az érintett kifejezett hozzájárulásával használunk.

10. Módosítások
A Szolgáltató fenntartja a jogot jelen adatvédelmi tájékoztató módosítására. A módosításokról a weboldalon történő közzététellel értesítjük a felhasználókat.

Utolsó frissítés: 2026. 03. 01.`;

const aszf = `Általános Szerződési Feltételek (ÁSZF)

1. Általános rendelkezések
Jelen Általános Szerződési Feltételek (továbbiakban: ÁSZF) tartalmazzák az AuraCode (továbbiakban: Szolgáltató) által nyújtott webfejlesztési és kapcsolódó szolgáltatások igénybevételének feltételeit.

A szolgáltatás igénybevételével az Ügyfél elfogadja jelen ÁSZF-ben foglalt feltételeket.

2. A Szolgáltató adatai
Név: AuraCode
E-mail: info@auracode.hu
Székhely: Budapest, Magyarország

3. Szolgáltatások
A Szolgáltató az alábbi szolgáltatásokat nyújtja:
- Egyedi weboldal tervezés és fejlesztés
- Reszponzív (mobilbarát) kialakítás
- SEO optimalizálás
- Weboldal karbantartás és frissítés
- Teljesítmény optimalizálás
- Domain és tárhely beállítás segítése

4. Megrendelési folyamat

4.1. Ajánlatkérés
Az Ügyfél a weboldalon található űrlap kitöltésével, e-mailben vagy telefonon kérhet ajánlatot. Az ajánlatkérés nem jelent szerződéses kötelezettséget.

4.2. Ajánlat
A Szolgáltató az ajánlatkérés beérkezésétől számított 3-5 munkanapon belül egyedi ajánlatot küld, amely tartalmazza a szolgáltatás részletes leírását, az árat és a teljesítési határidőt.

4.3. Szerződéskötés
A szerződés az ajánlat Ügyfél általi írásbeli elfogadásával és az előleg befizetésével jön létre.

5. Árak és fizetési feltételek

5.1. Árak
Az árak egyedi kalkuláció alapján kerülnek meghatározásra a projekt komplexitásától függően. Az ajánlatban szereplő árak magyar forintban (HUF) értendők és tartalmazzák az ÁFA-t.

5.2. Fizetési ütemezés
- Előleg: A teljes összeg 50%-a a szerződéskötéskor
- Közbenső részlet: 30% a fejlesztés közbenső mérföldkövénél (ha szükséges)
- Végelszámolás: 50% a projekt átadásakor (kisebb projekteknél) vagy 20% nagyobb projekteknél

5.3. Fizetési módok
Banki átutalás, azonnali banki átutalás, online bankkártyás fizetés.

5.4. Késedelmes fizetés
Késedelmes fizetés esetén a Szolgáltató jogosult a munkát felfüggeszteni és a Ptk. szerinti késedelmi kamatot felszámítani.

6. Teljesítési határidő
A teljesítési határidőt az egyedi ajánlat tartalmazza. A határidő akkor kezdődik, amikor:
- Az előleg beérkezett a Szolgáltató számlájára
- Az Ügyfél minden szükséges tartalmat és anyagot átadott
- A projekt részletei véglegesítésre kerültek

Az Ügyfél általi késedelmes anyagátadás vagy döntéshozatal esetén a határidő arányosan meghosszabbodik.

7. Az Ügyfél kötelezettségei
- Időben biztosítja a szükséges tartalmakat, logókat, képeket és egyéb anyagokat
- Egyértelmű és részletes visszajelzéseket ad a munka során
- Biztosítja, hogy a rendelkezésre bocsátott anyagok nem sértik harmadik felek jogait
- Időben fizeti a megállapított díjakat

8. Szerzői jogok

8.1. Tulajdonjog
A kész weboldal forráskódja és design elemei a teljes vételár kiegyenlítését követően az Ügyfél tulajdonába kerülnek. Addig a Szolgáltató tulajdona.

8.2. Portfólió használat
A Szolgáltató jogosult a létrehozott weboldalt portfóliójában bemutatni és marketingcélokra felhasználni, kivéve, ha az Ügyfél ezt írásban megtiltja.

8.3. Harmadik féltől származó elemek
A weboldalon használt stock fotók, ikonok, betűtípusok és egyéb harmadik féltől származó elemek licencei az Ügyfelet terhelik.

9. Módosítások és kiegészítések

9.1. Ingyenes módosítások
A fejlesztési folyamat során legfeljebb 3 körös visszajelzés és módosítás díjmentesen biztosított.

9.2. További módosítások
A harmadik kör utáni módosítások vagy a projekt lényeges átalakítása külön megállapodás és díjazás alapján történik.

9.3. Átadás utáni módosítások
Az átadást követő módosítások óradíjas alapon vagy karbantartási csomagok keretében igényelhetők.

10. Garancia és karbantartás

10.1. Garancia
A Szolgáltató 30 napos garanciát vállal az átadástól számítva a programhibák javítására.

10.2. Karbantartás
A rendszeres karbantartás, frissítések és támogatás külön megállapodás alapján vehető igénybe.

11. Felelősség korlátozása
- A Szolgáltató nem felel az Ügyfél által szolgáltatott tartalmak jogszerűségéért
- Nem felel harmadik felek (pl. tárhely szolgáltató) működési zavaraiért
- Nem felel az Ügyfél által telepített harmadik féltől származó kódok hibáiért
- Kártérítési felelőssége a szerződés értékére korlátozódik

12. Szerződés megszüntetése

12.1. Közös megegyezéssel
A szerződés bármikor megszüntethető közös megegyezéssel. Az addig elvégzett munkát ki kell fizetni.

12.2. Ügyfél általi felmondás
Az Ügyfél írásban felmondhatja a szerződést. Az előleg nem kerül visszatérítésre.

12.3. Szolgáltató általi felmondás
Szolgáltató azonnali hatállyal felmondhatja a szerződést, ha az Ügyfél fizetési kötelezettségének 30 napon túl nem tesz eleget.

13. Egyéb rendelkezések
- A felek közötti kommunikáció e-mailben vagy telefonon történik
- A szerződésre a magyar jog az irányadó
- Vitás esetben a felek elsősorban békés megegyezésre törekszenek
- Megegyezés hiányában a Pesti Központi Kerületi Bíróság illetékes

14. Hatálybalépés
Jelen ÁSZF 2026. 03. 01. napján lép hatályba, és visszavonásig érvényes.

15. Módosítás joga
A Szolgáltató fenntartja a jogot az ÁSZF egyoldalú módosítására. A módosításokról a weboldalon történő közzététellel értesíti az ügyfeleket.

Utolsó frissítés: 2026. 03. 01.`;

export const LegalModal = ({ type, onClose }) => {
  const isPrivacy = type === 'privacy';
  const title = isPrivacy ? 'Adatvédelmi nyilatkozat' : 'Általános Szerződési Feltételek';
  const content = isPrivacy ? privacy : aszf;

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" />
      <div
        className="relative bg-[#161616] border border-[#ffffff15] rounded-2xl w-full max-w-2xl max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-8 py-5 border-b border-[#ffffff10]">
          <h2 className="text-lg font-bold text-white">{title}</h2>
          <button
            onClick={onClose}
            className="text-[#52525B] hover:text-white transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="overflow-y-auto px-8 py-6 text-[#A1A1AA] text-sm leading-relaxed whitespace-pre-wrap">
          {content}
        </div>
      </div>
    </div>
  );
};
